import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataAction } from '@onefootprint/request-types/dashboard';
import type { NodeProps } from '../../playbook-builder.types';
import ActionForm from '../action-form';
import BaseNode from '../base-node';
export const ActionNode = t0 => {
  const $ = _c(7);
  const {
    id,
    data
  } = t0;
  let t1;
  if ($[0] !== data || $[1] !== id) {
    t1 = {
      form: "action-form",
      render: t2 => {
        const {
          mutation
        } = t2;
        return <ActionForm nodeId={id} data={data} subject={data.subject} mutation={mutation} />;
      }
    };
    $[0] = data;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== data || $[4] !== id || $[5] !== t1) {
    t2 = <BaseNode nodeId={id} data={data} sidebar={t1} />;
    $[3] = data;
    $[4] = id;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};